<template>
  <div>
    <v-card>
      <s-crud
        :config="config"
        title="Horarios"
        :filter="filter"
        search-input
        add
        edit
        remove
        @save="saveSchedule($event)"
        ref="scrudSchedules"
        @rowSelected="ScheduleSelected($event)"
      >
        <template v-slot="props">
          <v-container>
            <v-row>
              <v-col sm="3" lg="3">
                <s-text
                  v-model="props.item.SdsSchedule"
                  label="Horario"
                  uppercase
                ></s-text>
              </v-col>
              <v-col sm="3">
                <s-select-definition
                  v-model="props.item.SdsTypeSchedule"
                  :def="1526"
                  label="Tipo de Horario"
                ></s-select-definition>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template v-slot:actions="{ row }">
          <div v-if="row.SdsID > 0" key="row.SdsID">
            <v-btn
              color="primary"
              x-small
              @click="dialogScheduleDetailOpen(row)"
              block
            >
              <v-icon small>mdi-calendar-edit</v-icon>
              Configurar Horarios
            </v-btn>
          </div>
        </template>
      </s-crud>

      <!-- DIALOG MEJORADO CON TODA LA FUNCIONALIDAD -->
      <v-dialog v-model="dialogScheduleDetail" width="1400" persistent>
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-calendar-edit</v-icon>
            Configuración de horario: {{ dialogName }}
            <v-spacer></v-spacer>
            <v-btn icon color="white" @click="dialogScheduleDetail = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="padding: 20px">
            <!-- FORMULARIO DE EDICIÓN RÁPIDA -->
            <v-container>
              <v-row class="align-center">
                <v-col cols="12" sm="3" md="2">
                  <s-select-definition
                    v-model="detail.SddType"
                    :def="1525"
                    label="Tipo"
                    outlined
                    dense
                    class="mb-2"
                  ></s-select-definition>
                </v-col>

                <v-col cols="6" sm="2" md="2">
                  <s-text
                    type="time"
                    v-model="detail.SddHourBegin"
                    label="Hora Inicio"
                    outlined
                    dense
                    class="mb-2"
                  ></s-text>
                </v-col>

                <v-col cols="6" sm="2" md="2">
                  <s-text
                    type="time"
                    v-model="detail.SddHourEnd"
                    label="Hora Final"
                    outlined
                    dense
                    class="mb-2"
                  ></s-text>
                </v-col>

                <v-col cols="12" sm="3" md="4">
                  <v-card outlined class="pa-2">
                    <div class="d-flex flex-wrap">
                      <v-checkbox
                        v-model="selectAll"
                        label="Todos"
                        @change="toggleSelectAll"
                        class="mr-2 mb-1"
                        dense
                        hide-details
                      ></v-checkbox>
                      <template v-for="item in days">
                        <v-checkbox
                          :value="item.DedValue"
                          v-model="detail.days"
                          :label="item.DedDescription.substring(0, 3)"
                          :key="item.DedValue"
                          class="mr-2 mb-1"
                          dense
                          hide-details
                        />
                      </template>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="2" md="2">
                  <v-btn
                    color="primary"
                    @click="saveDetails"
                    :loading="isLoading"
                    block
                    small
                  >
                    <v-icon left small>mdi-content-save</v-icon>
                    Guardar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>

            <v-divider class="my-3"></v-divider>

            <!-- TABLA MEJORADA CON FUNCIONALIDADES AVANZADAS -->
            <v-row>
              <v-col cols="12">
                <v-card outlined>
                  <v-card-title class="py-2">
                    <v-icon left>mdi-calendar-clock</v-icon>
                    Configuración de Horarios
                    <v-spacer></v-spacer>
                    <v-chip color="info" small>
                      <v-icon left x-small>mdi-information</v-icon>
                      Click en las celdas para editar
                    </v-chip>
                  </v-card-title>
                  <v-card-text class="pa-0">
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <!-- FILA 1: Encabezados principales -->
                          <tr>
                            <th
                              rowspan="2"
                              class="text-center"
                              style="
                                width: 80px;
                                background-color: #37474f;
                                color: white;
                                border: 1px solid #fff;
                              "
                            >
                              <strong>Día</strong>
                            </th>
                            <th
                              v-for="type in getVisibleTypeSchedules()"
                              :key="'header-' + type.DedValue"
                              :colspan="getColspanForType(type)"
                              class="text-center"
                              style="
                                border: 1px solid #fff;
                                font-weight: bold;
                                color: white;
                              "
                              :style="{
                                backgroundColor: getTypeColor(
                                  type.DedDescription
                                ),
                              }"
                            >
                              {{ type.DedDescription }}
                            </th>

                            <!-- COLUMNA MIN REF - SOLO SI HAY HORARIOS DE REFRIGERIO -->
                            <th
                              v-if="hasRefreshmentSchedules()"
                              rowspan="2"
                              class="text-center"
                              style="
                                width: 120px;
                                background-color: #4caf50;
                                color: white;
                                border: 1px solid #fff;
                              "
                            >
                              <v-icon small color="white">mdi-coffee</v-icon>
                              Min Ref.
                            </th>
                          </tr>

                          <!-- FILA 2: Sub-encabezados -->
                          <tr>
                            <template v-for="type in getVisibleTypeSchedules()">
                              <th
                                :key="'sub-ent-' + type.DedValue"
                                class="text-center"
                                style="
                                  background-color: rgba(255, 255, 255, 0.9);
                                  font-size: 11px;
                                  border: 1px solid #fff;
                                  padding: 4px;
                                "
                              >
                                Hora Ent.
                              </th>
                              <th
                                :key="'sub-sal-' + type.DedValue"
                                class="text-center"
                                style="
                                  background-color: rgba(255, 255, 255, 0.9);
                                  font-size: 11px;
                                  border: 1px solid #fff;
                                  padding: 4px;
                                "
                              >
                                Hora Sal.
                              </th>

                              <!-- COLUMNA ACCIONES -->
                              <th
                                :key="'sub-actions-' + type.DedValue"
                                class="text-center"
                                style="
                                  background-color: #607d8b;
                                  color: white;
                                  font-size: 11px;
                                  border: 1px solid #fff;
                                  padding: 4px;
                                  width: 80px;
                                "
                              >
                                <v-icon x-small color="white">mdi-cog</v-icon>
                                Acciones
                              </th>

                              <!-- COLUMNA HORAS LABORALES (solo para HLAB) -->
                              <th
                                v-if="isLaboralType(type)"
                                :key="'sub-hours-' + type.DedValue"
                                class="text-center"
                                style="
                                  background-color: #ff9800;
                                  color: white;
                                  font-size: 11px;
                                  border: 1px solid #fff;
                                  padding: 4px;
                                  font-weight: bold;
                                "
                              >
                                <v-icon x-small color="white"
                                  >mdi-clock-time-eight</v-icon
                                >
                                Horas Lab.
                              </th>
                            </template>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="day in days" :key="'row-' + day.DedValue">
                            <!-- COLUMNA DÍA -->
                            <td
                              class="text-center"
                              style="
                                background-color: #37474f;
                                color: white;
                                font-weight: bold;
                                border: 1px solid #fff;
                              "
                            >
                              {{ day.DedDescription }}
                            </td>

                            <!-- COLUMNAS POR TIPO DE HORARIO -->
                            <template v-for="type in getVisibleTypeSchedules()">
                              <!-- HORA ENTRADA -->
                              <td
                                :key="
                                  'ent-' + day.DedValue + '-' + type.DedValue
                                "
                                class="text-center schedule-cell"
                                style="border: 1px solid #fff; cursor: pointer"
                                :style="
                                  getCellStyle(
                                    day.DedValue,
                                    type.DedValue,
                                    'begin'
                                  )
                                ">
                                <span
                                  v-if="
                                    getSchedule(day.DedValue, type.DedValue)
                                  "
                                >
                                  {{
                                    getSchedule(day.DedValue, type.DedValue)
                                      .SddHourBegin
                                  }}
                                </span>
                                <span v-else class="grey--text">
                                  <!-- <v-icon x-small color="grey">mdi-plus</v-icon> -->
                                  ---
                                </span>
                              </td>

                              <!-- HORA SALIDA -->
                              <td
                                :key="
                                  'sal-' + day.DedValue + '-' + type.DedValue
                                "
                                class="text-center schedule-cell"
                                style="border: 1px solid #fff; cursor: pointer"
                                :style="
                                  getCellStyle(
                                    day.DedValue,
                                    type.DedValue,
                                    'end'
                                  )
                                ">
                                <span
                                  v-if="
                                    getSchedule(day.DedValue, type.DedValue)
                                  "
                                >
                                  {{
                                    getSchedule(day.DedValue, type.DedValue)
                                      .SddHourEnd
                                  }}
                                </span>
                                <span v-else class="grey--text">
                                  <!-- <v-icon x-small color="grey">mdi-plus</v-icon> -->
                                  ---
                                </span>
                              </td>

                              <!-- COLUMNA ACCIONES -->
                              <td
                                :key="
                                  'actions-' +
                                  day.DedValue +
                                  '-' +
                                  type.DedValue
                                "
                                class="text-center actions-cell"
                                style="
                                  border: 1px solid #fff;
                                  background-color: #fafafa;
                                  padding: 2px;
                                  width: 80px;
                                "
                              >
                                <div
                                  v-if="
                                    getSchedule(day.DedValue, type.DedValue)
                                  "
                                  class="d-flex justify-center"
                                >
                                  <!-- BOTÓN EDITAR -->
                                  <v-btn
                                    @click="
                                      editScheduleCell(
                                        day.DedValue,
                                        type.DedValue,
                                        'begin'
                                      )
                                    "
                                    color="primary"
                                    icon
                                    x-small
                                    class="ma-1"
                                    :title="`Editar ${type.DedDescription}`"
                                  >
                                    <v-icon x-small>mdi-pencil</v-icon>
                                  </v-btn>

                                  <!-- BOTÓN ELIMINAR -->
                                  <v-btn
                                    @click="
                                      deleteSingleSchedule(
                                        getSchedule(day.DedValue, type.DedValue)
                                      )
                                    "
                                    color="error"
                                    icon
                                    x-small
                                    class="ma-1"
                                    :title="`Eliminar ${type.DedDescription}`"
                                  >
                                    <v-icon x-small>mdi-delete</v-icon>
                                  </v-btn>
                                </div>

                                <!-- BOTÓN AGREGAR -->
                                <div v-else class="d-flex justify-center">
                                  <v-btn
                                    @click="
                                      addScheduleForDayAndType(
                                        day.DedValue,
                                        type.DedValue
                                      )
                                    "
                                    icon
                                    x-small
                                    class="ma-1"
                                    :title="`Agregar ${type.DedDescription}`"
                                  >
                                    <v-icon x-small color="success"
                                      >mdi-plus</v-icon
                                    >
                                  </v-btn>
                                </div>
                              </td>

                              <!-- COLUMNA HORAS LABORALES -->
                              <td
                                v-if="isLaboralType(type)"
                                :key="
                                  'hours-' + day.DedValue + '-' + type.DedValue
                                "
                                class="text-center"
                                style="
                                  background-color: #fff3e0;
                                  border: 1px solid #fff;
                                  padding: 4px;
                                "
                              >
                                <v-chip
                                  v-if="
                                    getSchedule(day.DedValue, type.DedValue)
                                  "
                                  :color="
                                    getLaboralHoursColor(
                                      day.DedValue,
                                      type.DedValue
                                    )
                                  "
                                  x-small
                                  :title="`Horas laborales calculadas: ${getLaboralHoursDetail(
                                    day.DedValue,
                                    type.DedValue
                                  )}`"
                                >
                                  <v-icon left x-small
                                    >mdi-clock-time-eight</v-icon
                                  >
                                  {{
                                    calculateLaboralHoursDisplay(
                                      day.DedValue,
                                      type.DedValue
                                    )
                                  }}
                                </v-chip>
                                <span v-else class="grey--text">---</span>
                              </td>
                            </template>

                            <!-- COLUMNA MIN REF. -->
                            <td
                              v-if="hasRefreshmentSchedules()"
                              class="text-center"
                              style="
                                background-color: #e8f5e8;
                                border: 1px solid #fff;
                                padding: 4px;
                              "
                            >
                              <v-chip
                                v-if="getRefreshmentMinutes(day.DedValue) > 0"
                                :color="getRefreshmentColor(day.DedValue)"
                                x-small
                                :title="`Calculado desde refrigerio: ${getHREFDetail(
                                  day.DedValue
                                )}`"
                              >
                                <v-icon left x-small>mdi-coffee</v-icon>
                                {{ calculateRefreshmentDisplay(day.DedValue) }}
                              </v-chip>
                              <span v-else class="grey--text">---</span>
                            </td>
                          </tr>

                          <!-- FILA DE SUMATORIA -->
                          <tr
                            style="
                              background-color: #f5f5f5;
                              border-top: 3px solid #37474f;
                            "
                          >
                            <td
                              class="text-center"
                              style="
                                background-color: #37474f;
                                color: white;
                                font-weight: bold;
                                border: 1px solid #fff;
                                font-size: 12px;
                              "
                            >
                              <v-icon small color="white">mdi-sigma</v-icon>
                              TOTAL
                            </td>

                            <template v-for="type in getVisibleTypeSchedules()">
                              <!-- COLUMNAS VACÍAS -->
                              <td
                                :key="'total-ent-' + type.DedValue"
                                style="
                                  background-color: #f0f0f0;
                                  border: 1px solid #fff;
                                "
                              ></td>
                              <td
                                :key="'total-sal-' + type.DedValue"
                                style="
                                  background-color: #f0f0f0;
                                  border: 1px solid #fff;
                                "
                              ></td>
                              <td
                                :key="'total-actions-' + type.DedValue"
                                style="
                                  background-color: #f0f0f0;
                                  border: 1px solid #fff;
                                "
                              ></td>

                              <!-- SUMATORIA HORAS LABORALES -->
                              <td
                                v-if="isLaboralType(type)"
                                :key="'total-hours-' + type.DedValue"
                                class="text-center"
                                style="
                                  background-color: #ff9800;
                                  color: white;
                                  font-weight: bold;
                                  border: 1px solid #fff;
                                  font-size: 11px;
                                "
                              >
                                <v-chip
                                  color="orange"
                                  dark
                                  small
                                  :title="`Total horas laborales semanales`"
                                >
                                  <v-icon left small>mdi-sigma</v-icon>
                                  {{ calculateTotalLaboralHours() }}
                                </v-chip>
                              </td>
                            </template>

                            <!-- SUMATORIA MIN REF. -->
                            <td
                              v-if="hasRefreshmentSchedules()"
                              class="text-center"
                              style="
                                background-color: #4caf50;
                                color: white;
                                font-weight: bold;
                                border: 1px solid #fff;
                                font-size: 11px;
                              "
                            >
                              <v-chip
                                color="green"
                                dark
                                small
                                title="Total minutos de refrigerio semanales"
                              >
                                <v-icon left small>mdi-sigma</v-icon>
                                {{ calculateTotalRefreshment() }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- ACCIONES RÁPIDAS -->
            <v-row class="mt-3">
              <v-col cols="12">
                <v-card outlined>
                  <v-card-title class="py-2">
                    <v-icon left>mdi-lightning-bolt</v-icon>
                    Acciones Rápidas
                  </v-card-title>
                  <v-card-text class="pa-3">
                    <!-- BOTONES CON EFECTOS VISUALES -->
                    <div class="d-flex flex-wrap mb-3">
                      <v-btn
                        v-for="type in getVisibleTypeSchedules()"
                        :key="'quick-' + type.DedValue"
                        :class="[
                          'ma-1',
                          'quick-action-btn',
                          {
                            'quick-action-selected':
                              quickActionType === type.DedValue,
                          },
                        ]"
                        :color="
                          quickActionType === type.DedValue ? 'white' : 'black'
                        "
                        :style="getQuickActionStyle(type)"
                        @click="selectQuickActionType(type.DedValue)"
                        small
                        outlined
                      >
                        <v-icon
                          left
                          x-small
                          :color="
                            quickActionType === type.DedValue
                              ? getTypeColor(type.DedDescription)
                              : 'black'
                          "
                        >
                          {{ getTypeIcon(type.DedDescription) }}
                        </v-icon>
                        {{ type.DedDescription }}
                      </v-btn>
                    </div>

                    <!-- CAMPOS DE TIEMPO CON ANIMACIÓN -->
                    <v-expand-transition>
                      <div v-if="quickActionType" class="quick-form-container">
                        <v-divider class="mb-3"></v-divider>
                        <div class="d-flex align-center">
                          <v-text-field
                            v-model="quickTimeBegin"
                            type="time"
                            label="Hora Inicio"
                            outlined
                            dense
                            class="mr-2 quick-time-field"
                            style="max-width: 150px"
                            :color="getSelectedTypeColor()"
                          ></v-text-field>
                          <v-text-field
                            v-model="quickTimeEnd"
                            type="time"
                            label="Hora Final"
                            outlined
                            dense
                            class="mr-2 quick-time-field"
                            style="max-width: 150px"
                            :color="getSelectedTypeColor()"
                          ></v-text-field>
                          <v-btn
                            :color="getSelectedTypeColor()"
                            :disabled="
                              !quickActionType ||
                              !quickTimeBegin ||
                              !quickTimeEnd
                            "
                            @click="applyToAllDays"
                            class="quick-apply-btn"
                          >
                            <v-icon left>mdi-content-copy</v-icon>
                            Aplicar a Todos los Días
                          </v-btn>
                        </div>

                        <!-- PREVIEW -->
                        <div class="mt-3">
                          <v-chip
                            small
                            :color="getSelectedTypeColor()"
                            class="white--text"
                          >
                            <v-icon left x-small>mdi-preview-outline</v-icon>
                            Preview: {{ getSelectedTypeName() }} |
                            {{ quickTimeBegin }} - {{ quickTimeEnd }}
                          </v-chip>
                        </div>
                      </div>
                    </v-expand-transition>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
    <s-load v-if="isLoading"></s-load>
  </div>
</template>

<script>
import SText from "../../../components/Utils/SText.vue";
import SLoad from "../../../components/Layout/Loader.vue";
import _SchedulesService from "../../../services/HumanResource/Schedules";
import _sDefinition from "@/services/General/DefinitionService.js";

export default {
  components: {
    SText,
    SLoad,
  },
  data() {
    return {
      paramsDef: {
        defID: 1524,
        dgrID: 0,
        requestID: this.$fun.getUserID(),
      },
      paramsDefScheduleType: {
        defID: 1525,
        dgrID: 0,
        requestID: this.$fun.getUserID(),
      },
      dialogName: "",
      selectAll: false,
      days: [],
      typeSchedules: [],
      // MEJORADO: detail unificado
      detail: {
        SddID: 0,
        SddType: 1,
        SddDate: 1,
        SddMin: 45,
        SddHourBegin: null,
        SddHourEnd: null,
        SddTypeName: null,
        SddDateName: null,
        SdsID: 0,
        days: [],
      },
      dialogScheduleDetail: false,
      isLoading: false,
      filter: {},
      config: {
        service: _SchedulesService,
        model: {
          SdsID: "ID",
          actions: "",
        },
        headers: [
          { text: "ID", value: "SdsID", width: 100 },
          { text: "Horario", value: "SdsSchedule" },
          { text: "Tipo de Horario", value: "SdsTypeScheduleName" },
          { text: "acciones", value: "actions" },
        ],
      },
      itemsScheduled: [],
      newSchedules: {},

      // NUEVOS: Para acciones rápidas
      quickActionType: null,
      quickTimeBegin: null,
      quickTimeEnd: null,
    };
  },

  // COMPUTED AGREGADOS DESDE SCHEDULEWORKER
  computed: {
    calculatedSddMin() {
      if (!this.detail.SddHourBegin || !this.detail.SddHourEnd) {
        return this.detail.SddMin || 45;
      }

      const beginTime = this.timeToMinutes(this.detail.SddHourBegin);
      let endTime = this.timeToMinutes(this.detail.SddHourEnd);

      if (beginTime > endTime) {
        endTime += 1440;
      }

      const diffMinutes = endTime - beginTime;
      const refrigerioTypes = [3]; // Ajustar según tus tipos
      if (refrigerioTypes.includes(this.detail.SddType)) {
        return diffMinutes;
      }

      return this.detail.SddMin || 45;
    },
  },

  methods: {
    // MÉTODOS BÁSICOS MEJORADOS
    getSchedule(dayValue, typeValue) {
      return (
        this.itemsScheduled.find(
          (s) => s.SddDate === dayValue && s.SddType === typeValue
        ) || null
      );
    },

    getVisibleTypeSchedules() {
      return this.typeSchedules.filter((type) => {
        return this.itemsScheduled.some(
          (schedule) => schedule.SddType === type.DedValue
        );
      });
    },

    // NUEVOS MÉTODOS DESDE SCHEDULEWORKER
    timeToMinutes(timeString) {
      if (!timeString) return 0;
      const [hours, minutes] = timeString.split(":").map(Number);
      return hours * 60 + minutes;
    },

    getCellStyle(dayValue, typeValue, timeType) {
      const schedule = this.getSchedule(dayValue, typeValue);
      if (schedule) {
        return {
          backgroundColor: "rgba(255,255,255,0.95)",
          fontWeight: "500",
        };
      } else {
        return {
          backgroundColor: "rgba(240,240,240,0.5)",
          fontStyle: "italic",
        };
      }
    },

    editScheduleCell(dayValue, typeValue, timeType) {
      const schedule = this.getSchedule(dayValue, typeValue);

      if (schedule) {
        // Editar existente
        this.detail = {
          ...schedule,
          days: [dayValue],
          SddType: typeValue,
        };
      } else {
        // Crear nuevo
        this.detail = {
          SddID: 0,
          SdsID: this.detail.SdsID,
          SddType: typeValue,
          SddHourBegin: timeType === "begin" ? "08:00" : null,
          SddHourEnd: timeType === "end" ? "17:00" : null,
          SddMin: 45,
          days: [dayValue],
        };
      }

      this.selectAll = false;
    },

    addScheduleForDayAndType(dayValue, typeValue) {
      this.detail = {
        SddID: 0,
        SdsID: this.detail.SdsID,
        SddType: typeValue,
        SddHourBegin: "08:00",
        SddHourEnd: "17:00",
        SddMin: 45,
        days: [dayValue],
      };
      this.selectAll = false;
    },

    deleteSingleSchedule(schedule) {
      const typeName =
        this.typeSchedules.find((t) => t.DedValue === schedule.SddType)
          ?.DedDescription || "horario";
      const dayName =
        this.days.find((d) => d.DedValue === schedule.SddDate)
          ?.DedDescription || "día";

      this.$fun
        .alert(`¿Eliminar ${typeName} del ${dayName}?`, "question")
        .then((resp) => {
          if (resp.value) {
            this.isLoading = true;
            _SchedulesService
              .deleteDetailByID(schedule.SddID, this.$fun.getUserID())
              .then((r) => {
                if (r.status === 200) {
                  this.ScheduleSelected([{ SdsID: this.detail.SdsID }]);
                  this.$fun.alert("Horario eliminado correctamente", "success");
                }
              })
              .catch((error) => {
                this.$fun.alert("Error al eliminar el horario", "error");
              })
              .finally(() => {
                this.isLoading = false;
              });
          }
        });
    },

    // MÉTODOS PARA MIN REF.
    hasRefreshmentSchedules() {
      const hrefTypeValue = 4;
      return this.itemsScheduled.some(
        (schedule) => schedule.SddType === hrefTypeValue
      );
    },

    getRefreshmentMinutes(dayValue) {
      const hrefTypeValue = 4;
      const hrefSchedule = this.itemsScheduled.find(
        (schedule) =>
          schedule.SddDate === dayValue && schedule.SddType === hrefTypeValue
      );

      if (!hrefSchedule) return 0;

      const beginTime = this.timeToMinutes(hrefSchedule.SddHourBegin);
      let endTime = this.timeToMinutes(hrefSchedule.SddHourEnd);

      if (hrefSchedule.SddHourBegin === hrefSchedule.SddHourEnd) return 0;

      if (beginTime > endTime) {
        endTime += 1440;
      }

      return endTime - beginTime;
    },

    calculateRefreshmentDisplay(dayValue) {
      const minutes = this.getRefreshmentMinutes(dayValue);
      if (minutes === 0) return "0 min";
      if (minutes < 60) {
        return `${minutes} min`;
      } else {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        return remainingMinutes > 0
          ? `${hours}h ${remainingMinutes}m`
          : `${hours}h`;
      }
    },

    getRefreshmentColor(dayValue) {
      const minutes = this.getRefreshmentMinutes(dayValue);
      if (minutes === 0) return "grey";
      if (minutes > 120) return "orange";
      if (minutes >= 60) return "blue";
      return "success";
    },

    getHREFDetail(dayValue) {
      const hrefSchedule = this.itemsScheduled.find(
        (schedule) => schedule.SddDate === dayValue && schedule.SddType === 4
      );
      if (!hrefSchedule) return "Sin refrigerio configurado";
      return `${hrefSchedule.SddHourBegin} - ${hrefSchedule.SddHourEnd}`;
    },

    calculateTotalRefreshment() {
      let totalMinutes = 0;
      this.days.forEach((day) => {
        totalMinutes += this.getRefreshmentMinutes(day.DedValue);
      });

      if (totalMinutes === 0) return "0 min";
      if (totalMinutes < 60) {
        return `${totalMinutes} min`;
      } else {
        const hours = Math.floor(totalMinutes / 60);
        const remainingMinutes = totalMinutes % 60;
        return remainingMinutes > 0
          ? `${hours}h ${remainingMinutes}m`
          : `${hours}h`;
      }
    },

    // MÉTODOS PARA HORAS LABORALES
    isLaboralType(type) {
      const desc = type.DedDescription.toLowerCase();
      return desc.includes("hlab") || desc.includes("horario laboral");
    },

    getColspanForType(type) {
      return this.isLaboralType(type) ? 4 : 3;
    },

    getLaboralHours(dayValue, typeValue) {
      const schedule = this.getSchedule(dayValue, typeValue);
      if (!schedule) return 0;

      const beginTime = this.timeToMinutes(schedule.SddHourBegin);
      let endTime = this.timeToMinutes(schedule.SddHourEnd);

      if (schedule.SddHourBegin === schedule.SddHourEnd) return 0;

      if (beginTime > endTime) {
        endTime += 1440;
      }

      return Math.round(((endTime - beginTime) / 60) * 100) / 100;
    },

    calculateLaboralHoursDisplay(dayValue, typeValue) {
      const hours = this.getLaboralHours(dayValue, typeValue);
      if (hours === 0) return "0h";

      const wholeHours = Math.floor(hours);
      const minutes = Math.round((hours - wholeHours) * 60);

      if (minutes === 0) {
        return `${wholeHours}h`;
      } else {
        return `${wholeHours}h ${minutes}m`;
      }
    },

    getLaboralHoursColor(dayValue, typeValue) {
      const hours = this.getLaboralHours(dayValue, typeValue);
      if (hours === 0) return "grey";
      if (hours < 4) return "red";
      if (hours < 8) return "orange";
      if (hours === 8) return "green";
      if (hours > 8 && hours <= 10) return "blue";
      return "purple";
    },

    getLaboralHoursDetail(dayValue, typeValue) {
      const schedule = this.getSchedule(dayValue, typeValue);
      if (!schedule) return "Sin horario laboral configurado";
      const hours = this.getLaboralHours(dayValue, typeValue);
      return `${schedule.SddHourBegin} - ${schedule.SddHourEnd} = ${hours} horas`;
    },

    calculateTotalLaboralHours() {
      let totalHours = 0;
      const laboralType = this.typeSchedules.find((type) =>
        this.isLaboralType(type)
      );
      if (!laboralType) return "0h";

      this.days.forEach((day) => {
        const schedule = this.getSchedule(day.DedValue, laboralType.DedValue);
        if (schedule) {
          totalHours += this.getLaboralHours(
            day.DedValue,
            laboralType.DedValue
          );
        }
      });

      const wholeHours = Math.floor(totalHours);
      const minutes = Math.round((totalHours - wholeHours) * 60);

      if (minutes === 0) {
        return `${wholeHours}h`;
      } else {
        return `${wholeHours}h ${minutes}m`;
      }
    },

    // MÉTODOS PARA ESTILOS Y COLORES
    getTypeColor(typeDescription) {
      const type = typeDescription.toLowerCase();
      if (type.includes("ilab") || type.includes("intervalo laboral")) {
        return "#2196F3";
      } else if (type.includes("hlab") || type.includes("horario laboral")) {
        return "#FF9800";
      } else if (
        type.includes("iref") ||
        (type.includes("intervalo") && type.includes("refrigerio"))
      ) {
        return "#9C27B0";
      } else if (type.includes("href") || type.includes("refrigerio")) {
        return "#4CAF50";
      } else {
        return "#607D8B";
      }
    },

    getTypeIcon(typeDescription) {
      const type = typeDescription.toLowerCase();
      if (type.includes("ilab") || type.includes("intervalo laboral")) {
        return "mdi-clock-outline";
      } else if (type.includes("hlab") || type.includes("horario laboral")) {
        return "mdi-briefcase-clock";
      } else if (
        type.includes("iref") ||
        (type.includes("intervalo") && type.includes("refrigerio"))
      ) {
        return "mdi-pause-circle-outline";
      } else if (type.includes("href") || type.includes("refrigerio")) {
        return "mdi-coffee";
      } else {
        return "mdi-clock";
      }
    },

    // MÉTODOS PARA ACCIONES RÁPIDAS
    selectQuickActionType(typeValue) {
      this.quickActionType = typeValue;
      if (this.quickTimeBegin || this.quickTimeEnd) {
        this.quickTimeBegin = null;
        this.quickTimeEnd = null;
      }
    },

    getQuickActionStyle(type) {
      const baseColor = this.getTypeColor(type.DedDescription);
      const isSelected = this.quickActionType === type.DedValue;

      if (isSelected) {
        return {
          backgroundColor: baseColor,
          color: "white",
          border: `3px solid ${baseColor}`,
          boxShadow: `0 0 15px ${baseColor}40`,
          transform: "scale(1.05)",
          fontWeight: "bold",
        };
      } else {
        return {
          backgroundColor: `${baseColor}20`,
          color: baseColor,
          border: `2px solid ${baseColor}60`,
          fontWeight: "500",
        };
      }
    },

    getSelectedTypeColor() {
      if (!this.quickActionType) return "primary";
      const selectedType = this.typeSchedules.find(
        (t) => t.DedValue === this.quickActionType
      );
      return selectedType
        ? this.getTypeColor(selectedType.DedDescription)
        : "primary";
    },

    getSelectedTypeName() {
      if (!this.quickActionType) return "";
      const selectedType = this.typeSchedules.find(
        (t) => t.DedValue === this.quickActionType
      );
      return selectedType ? selectedType.DedDescription : "";
    },

    applyToAllDays() {
      if (!this.quickActionType || !this.quickTimeBegin || !this.quickTimeEnd)
        return;

      const selectedTypeName = this.getSelectedTypeName();

      this.$fun
        .alert(
          `¿Aplicar horario ${selectedTypeName} (${this.quickTimeBegin} - ${this.quickTimeEnd}) a todos los días?`,
          "question"
        )
        .then((resp) => {
          if (resp.value) {
            // Preparar detail con todos los días
            this.detail = {
              SddID: 0,
              SdsID: this.detail.SdsID,
              SddType: this.quickActionType,
              SddHourBegin: this.quickTimeBegin,
              SddHourEnd: this.quickTimeEnd,
              SddMin: 45,
              days: this.days.map((d) => d.DedValue), // Array de enteros
            };

            this.selectAll = true;

            // Guardar inmediatamente
            this.saveDetails();

            // Limpiar después de guardar
            setTimeout(() => {
              this.quickActionType = null;
              this.quickTimeBegin = null;
              this.quickTimeEnd = null;
            }, 1000);
          }
        });
    },

    // MÉTODOS PRINCIPALES MEJORADOS
    editDetailSchedule(item) {
      this.detail = {
        ...item,
        days: [item.SddDate],
      };
      this.selectAll = false;
    },

    deleteDetailSchedule(item) {
      this.$fun.alert("Desea eliminar registro?", "question").then((r) => {
        if (r.value) {
          this.isLoading = true;
          _SchedulesService
            .deleteDetailByID(item.SddID, this.$fun.getUserID())
            .then((r) => {
              if (r.status === 200) {
                this.ScheduleSelected([{ SdsID: item.SdsID }]);
                this.$fun.alert("Registro eliminado.", "success");
              }
            })
            .catch((error) => {
              this.$fun.alert(error, "error");
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      });
    },

    toggleSelectAll() {
      if (this.selectAll) {
        this.detail.days = this.days.map((item) => item.DedValue);
      } else {
        this.detail.days = [];
      }
    },

    saveDetails() {
      if (!this.validateInputs()) return;
      this.isLoading = true;

      // Preparar objeto exacto para tu API
      const requestPayload = {
        SdsID: this.detail.SdsID,
        SddType: this.detail.SddType,
        SddMin: this.detail.SddMin || this.calculatedSddMin || 45,
        SddHourBegin: this.detail.SddHourBegin,
        SddHourEnd: this.detail.SddHourEnd,
        Days: this.detail.days, // Array de enteros como espera tu API
      };

      // Usar tu servicio existente con el objeto correcto
      _SchedulesService
        .saveDetailsByID(requestPayload, this.$fun.getUserID())
        .then((response) => {
          if (response.status === 200) {
            this.ScheduleSelected([{ SdsID: this.detail.SdsID }]);
            this.clearInputs();
            this.$fun.alert("Horarios guardados exitosamente", "success");
          }
        })
        // .catch((error) => {
        //   console.error("❌ Error al guardar:", error);
        //   this.$fun.alert("Error al guardar horarios", "error");
        // })
        .finally(() => {
          this.isLoading = false;
        });
    },

    clearInputs() {
      this.detail = {
        SddID: 0,
        SddType: 1,
        SddMin: 45,
        SddHourBegin: null,
        SddHourEnd: null,
        SdsID: this.detail.SdsID,
        days: [],
      };
      this.selectAll = false;
    },

    validateInputs() {
      if (!this.detail.SddHourBegin || !this.detail.SddHourEnd) {
        this.$fun.alert(
          "Debe seleccionar una hora de inicio y fin.",
          "warning"
        );
        return false;
      }

      if (!this.detail.days || this.detail.days.length === 0) {
        this.$fun.alert("Debe seleccionar al menos un día.", "warning");
        return false;
      }

      if (this.detail.SddMin < 0) {
        this.$fun.alert(
          "El tiempo de refrigerio no puede ser menor a 0.",
          "warning"
        );
        return false;
      }

      if (!this.detail.SdsID || this.detail.SdsID <= 0) {
        this.$fun.alert("Debe seleccionar un horario válido.", "warning");
        return false;
      }

      return true;
    },

    dialogScheduleDetailOpen(event) {
      this.dialogName = event.SdsSchedule || "Nuevo";
      this.detail.SdsID = event.SdsID;
      this.clearInputs();
      this.dialogScheduleDetail = true;
    },

    saveSchedule(item) {
      item.UsrCreateID = this.$fun.getUserID();
      item.save();
    },

    ScheduleSelected(item) {
      if (item.length > 0) {
        this.detail.SdsID = item[0].SdsID;
        _SchedulesService
          .getDetailsByID(item[0].SdsID, this.$fun.getUserID())
          .then((r) => {
            if (r.status === 200) {
              this.itemsScheduled = r.data;
            }
          })
          .catch((error) => {
            this.$fun.alert(error, "error");
          });
      } else {
        this.itemsScheduled = [];
      }
    },
  },

  // WATCHERS PARA CÁLCULOS AUTOMÁTICOS
  watch: {
    "detail.SddHourBegin"() {
      if (this.detail.SddType && [3, 4].includes(this.detail.SddType)) {
        this.detail.SddMin = this.calculatedSddMin;
      }
    },
    "detail.SddHourEnd"() {
      if (this.detail.SddType && [3, 4].includes(this.detail.SddType)) {
        this.detail.SddMin = this.calculatedSddMin;
      }
    },
    "detail.SddType"() {
      if ([3, 4].includes(this.detail.SddType)) {
        this.detail.SddMin = this.calculatedSddMin;
      }
    },
  },

  mounted() {
    this.days.forEach((day) => {
      this.typeSchedules.forEach((type) => {
        this.$set(this.newSchedules, `${day.DedValue}-${type.DedValue}`, {
          SddHourBegin: "00:00",
          SddHourEnd: "00:00",
          SddMin: "45",
        });
      });
    });
  },

  created() {
    Promise.all([
      _sDefinition.definitiongroup(
        this.paramsDef.defID,
        this.paramsDef.dgrID,
        this.paramsDef.requestID
      ),
      _sDefinition.definitiongroup(
        this.paramsDefScheduleType.defID,
        this.paramsDefScheduleType.dgrID,
        this.paramsDefScheduleType.requestID
      ),
    ])
      .then(([daysResponse, typesResponse]) => {
        this.days = daysResponse.data;
        this.typeSchedules = typesResponse.data;

        this.days.forEach((day) => {
          this.typeSchedules.forEach((type) => {
            this.$set(this.newSchedules, `${day.DedValue}-${type.DedValue}`, {
              SddHourBegin: "00:00",
              SddHourEnd: "00:00",
              SddMin: "45",
            });
          });
        });
      })
      .catch(() => {
        this.$fun.alert("No se pudieron cargar los datos.");
      });
  },
};
</script>

<style scoped>
/* TODOS LOS ESTILOS DESDE SCHEDULEWORKER */
.schedule-cell {
  transition: all 0.2s ease;
  min-height: 40px;
  vertical-align: middle;
}

.schedule-cell:hover {
  background-color: rgba(33, 150, 243, 0.1) !important;
  transform: scale(1.02);
  cursor: pointer;
}

.v-simple-table table {
  border-collapse: separate !important;
  border-spacing: 1px !important;
}

.v-simple-table th,
.v-simple-table td {
  padding: 6px !important;
  font-size: 11px !important;
}

.v-chip.v-size--x-small {
  font-size: 9px !important;
  height: 18px !important;
}

.quick-action-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
  overflow: hidden;
}

.quick-action-btn:hover {
  transform: scale(1.02) !important;
  z-index: 2;
}

.quick-action-selected {
  animation: selectedGlow 2s ease-in-out infinite;
  z-index: 3;
}

@keyframes selectedGlow {
  0%,
  100% {
    box-shadow: 0 0 15px rgba(76, 175, 80, 0.4);
  }
  50% {
    box-shadow: 0 0 25px rgba(76, 175, 80, 0.7);
  }
}

.quick-form-container {
  background: linear-gradient(145deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  padding: 16px;
  border: 2px solid #e9ecef;
  position: relative;
}

.quick-form-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #2196f3, #ff9800, #9c27b0, #4caf50);
  border-radius: 8px 8px 0 0;
}

.quick-time-field {
  transition: all 0.3s ease;
}

.quick-time-field:focus-within {
  transform: scale(1.02);
}

.quick-apply-btn {
  transition: all 0.3s ease !important;
  font-weight: bold !important;
}

.quick-apply-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

.actions-cell {
  min-width: 80px !important;
  max-width: 80px !important;
}

.actions-cell .v-btn {
  margin: 1px !important;
}

@media (max-width: 1200px) {
  .actions-cell {
    min-width: 60px !important;
    max-width: 60px !important;
  }

  .actions-cell .v-btn {
    width: 20px !important;
    height: 20px !important;
  }
}

@media (max-width: 768px) {
  .quick-action-btn {
    margin: 2px !important;
    font-size: 11px !important;
  }

  .quick-form-container {
    padding: 12px;
  }
}
</style>
